import { createFileRoute } from '@tanstack/react-router';
import { TeamsPage } from '../../features/settings/components/teams-page.js';

export const Route = createFileRoute('/admin/teams')({ component: TeamsPage });
